import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMainBenefits, LazyMainFAQ, LazyMainFeatured, LazyMainHero, LazyMainPromo, LazyMainSteps, LazyMainTodaysPicks, LazyMainTokenization, LazyMainTrendingCountries, LazyMainTrustStrip, LazyMainCustomCarousel, LazyBaseAprIrr, LazyBaseButton, LazyBaseComingSoon, LazyBaseCookiePopUp, LazyBaseCookieSettingsPopUp, LazyBaseCustomSelectAcreage, LazyBaseCustomSelectCountry, LazyBaseCustomSelect, LazyBaseCustomSelectStage, LazyBaseCustomSelectToken, LazyBaseCustomSelectTypes, LazyBaseErrorBackdrop, LazyBaseFaq, LazyBaseFavoriteAdd, LazyBaseFieldBlocker, LazyBaseFilesUploaderImgPreview, LazyBaseFilesUploader, LazyBaseFooter, LazyBaseGallery, LazyBaseGetInTouch, LazyBaseHeader, LazyBaseIcon, LazyBaseInputButton, LazyBaseLanguageButton, LazyBaseLoader, LazyBaseLogoLoader, LazyBaseModalСonfirmation, LazyBaseNavigatorFiltersCheckbox, LazyBaseNavigatorFiltersInputRange, LazyBaseNavigatorFiltersMultyButts, LazyBaseNavigator, LazyBaseNavigatorTypes, LazyBasePageLoader, LazyBasePageTabs, LazyBasePaginator, LazyBasePriceRangeSlider, LazyBaseProgressBar, LazyBasePropertyInfo, LazyBaseRangeSlider, LazyBaseReviewsBlock, LazyBaseReviewsLeaveReview, LazyBaseReviewsLeaveReviewPopup, LazyBaseReviewsSingle, LazyBaseSearchCardPropertyTag, LazyBaseSearchCardSoldOutTag, LazyBaseSearchDesktop, LazyBaseSearch, LazyBaseSeparator, LazyBaseSubscribe, LazyBaseSuggestedEstates, LazyBaseTag, LazyBaseTooltip, LazyBaseUnitTimeline, LazyCalculator, LazyDirectorySearchActiveChips, LazyDirectorySearchAllFiltersDrawer, LazyDirectorySearchMapPanel, LazyDirectorySearchTopBar, LazyFavoriteFavoritePopUp, LazyLegalSidebar, LazyListingCard, LazyLoginLoginPopUp, LazyLoginRestorePopUp, LazyMapSidebar, LazyMapStatic, LazyMobileSwiperGallery, LazyNativeCurrency, LazyPhotoWall, LazyProfileFavorites, LazyProfileMobileUserSettingsPopUp, LazyProfileReviews, LazyProfileReviewsStatusBadge, LazyProfileUserSettingsPopUp, LazyProviderProviderPopUp, LazyRadarChart, LazySearchMobileFilter, LazySearchPageListing, LazySearchPageNoObjects, LazySwiperGallery, LazySwiperSlider, LazyTokenStockChart, LazyUnitPageEstateUnit, LazyUnitPageFinanceBlockComponentsInvestmentBlock, LazyUnitPageFinanceBlockEstate, LazyUnitPageFinanceBlockLand, LazyUnitPageInfoBlock, LazyUnitPageLandUnit, LazyUnitPageMobileBuyBar, LazyUnitPageSkeleton, LazyUnitPageTypes, LazyUnitPageUnit, LazyUnitPageWhatYouGet, LazyUnitPageYieldBreakdown, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["MainBenefits", LazyMainBenefits],
["MainFAQ", LazyMainFAQ],
["MainFeatured", LazyMainFeatured],
["MainHero", LazyMainHero],
["MainPromo", LazyMainPromo],
["MainSteps", LazyMainSteps],
["MainTodaysPicks", LazyMainTodaysPicks],
["MainTokenization", LazyMainTokenization],
["MainTrendingCountries", LazyMainTrendingCountries],
["MainTrustStrip", LazyMainTrustStrip],
["MainCustomCarousel", LazyMainCustomCarousel],
["BaseAprIrr", LazyBaseAprIrr],
["BaseButton", LazyBaseButton],
["BaseComingSoon", LazyBaseComingSoon],
["BaseCookiePopUp", LazyBaseCookiePopUp],
["BaseCookieSettingsPopUp", LazyBaseCookieSettingsPopUp],
["BaseCustomSelectAcreage", LazyBaseCustomSelectAcreage],
["BaseCustomSelectCountry", LazyBaseCustomSelectCountry],
["BaseCustomSelect", LazyBaseCustomSelect],
["BaseCustomSelectStage", LazyBaseCustomSelectStage],
["BaseCustomSelectToken", LazyBaseCustomSelectToken],
["BaseCustomSelectTypes", LazyBaseCustomSelectTypes],
["BaseErrorBackdrop", LazyBaseErrorBackdrop],
["BaseFaq", LazyBaseFaq],
["BaseFavoriteAdd", LazyBaseFavoriteAdd],
["BaseFieldBlocker", LazyBaseFieldBlocker],
["BaseFilesUploaderImgPreview", LazyBaseFilesUploaderImgPreview],
["BaseFilesUploader", LazyBaseFilesUploader],
["BaseFooter", LazyBaseFooter],
["BaseGallery", LazyBaseGallery],
["BaseGetInTouch", LazyBaseGetInTouch],
["BaseHeader", LazyBaseHeader],
["BaseIcon", LazyBaseIcon],
["BaseInputButton", LazyBaseInputButton],
["BaseLanguageButton", LazyBaseLanguageButton],
["BaseLoader", LazyBaseLoader],
["BaseLogoLoader", LazyBaseLogoLoader],
["BaseModalСonfirmation", LazyBaseModalСonfirmation],
["BaseNavigatorFiltersCheckbox", LazyBaseNavigatorFiltersCheckbox],
["BaseNavigatorFiltersInputRange", LazyBaseNavigatorFiltersInputRange],
["BaseNavigatorFiltersMultyButts", LazyBaseNavigatorFiltersMultyButts],
["BaseNavigator", LazyBaseNavigator],
["BaseNavigatorTypes", LazyBaseNavigatorTypes],
["BasePageLoader", LazyBasePageLoader],
["BasePageTabs", LazyBasePageTabs],
["BasePaginator", LazyBasePaginator],
["BasePriceRangeSlider", LazyBasePriceRangeSlider],
["BaseProgressBar", LazyBaseProgressBar],
["BasePropertyInfo", LazyBasePropertyInfo],
["BaseRangeSlider", LazyBaseRangeSlider],
["BaseReviewsBlock", LazyBaseReviewsBlock],
["BaseReviewsLeaveReview", LazyBaseReviewsLeaveReview],
["BaseReviewsLeaveReviewPopup", LazyBaseReviewsLeaveReviewPopup],
["BaseReviewsSingle", LazyBaseReviewsSingle],
["BaseSearchCardPropertyTag", LazyBaseSearchCardPropertyTag],
["BaseSearchCardSoldOutTag", LazyBaseSearchCardSoldOutTag],
["BaseSearchDesktop", LazyBaseSearchDesktop],
["BaseSearch", LazyBaseSearch],
["BaseSeparator", LazyBaseSeparator],
["BaseSubscribe", LazyBaseSubscribe],
["BaseSuggestedEstates", LazyBaseSuggestedEstates],
["BaseTag", LazyBaseTag],
["BaseTooltip", LazyBaseTooltip],
["BaseUnitTimeline", LazyBaseUnitTimeline],
["Calculator", LazyCalculator],
["DirectorySearchActiveChips", LazyDirectorySearchActiveChips],
["DirectorySearchAllFiltersDrawer", LazyDirectorySearchAllFiltersDrawer],
["DirectorySearchMapPanel", LazyDirectorySearchMapPanel],
["DirectorySearchTopBar", LazyDirectorySearchTopBar],
["FavoriteFavoritePopUp", LazyFavoriteFavoritePopUp],
["LegalSidebar", LazyLegalSidebar],
["ListingCard", LazyListingCard],
["LoginLoginPopUp", LazyLoginLoginPopUp],
["LoginRestorePopUp", LazyLoginRestorePopUp],
["MapSidebar", LazyMapSidebar],
["MapStatic", LazyMapStatic],
["MobileSwiperGallery", LazyMobileSwiperGallery],
["NativeCurrency", LazyNativeCurrency],
["PhotoWall", LazyPhotoWall],
["ProfileFavorites", LazyProfileFavorites],
["ProfileMobileUserSettingsPopUp", LazyProfileMobileUserSettingsPopUp],
["ProfileReviews", LazyProfileReviews],
["ProfileReviewsStatusBadge", LazyProfileReviewsStatusBadge],
["ProfileUserSettingsPopUp", LazyProfileUserSettingsPopUp],
["ProviderProviderPopUp", LazyProviderProviderPopUp],
["RadarChart", LazyRadarChart],
["SearchMobileFilter", LazySearchMobileFilter],
["SearchPageListing", LazySearchPageListing],
["SearchPageNoObjects", LazySearchPageNoObjects],
["SwiperGallery", LazySwiperGallery],
["SwiperSlider", LazySwiperSlider],
["TokenStockChart", LazyTokenStockChart],
["UnitPageEstateUnit", LazyUnitPageEstateUnit],
["UnitPageFinanceBlockComponentsInvestmentBlock", LazyUnitPageFinanceBlockComponentsInvestmentBlock],
["UnitPageFinanceBlockEstate", LazyUnitPageFinanceBlockEstate],
["UnitPageFinanceBlockLand", LazyUnitPageFinanceBlockLand],
["UnitPageInfoBlock", LazyUnitPageInfoBlock],
["UnitPageLandUnit", LazyUnitPageLandUnit],
["UnitPageMobileBuyBar", LazyUnitPageMobileBuyBar],
["UnitPageSkeleton", LazyUnitPageSkeleton],
["UnitPageTypes", LazyUnitPageTypes],
["UnitPageUnit", LazyUnitPageUnit],
["UnitPageWhatYouGet", LazyUnitPageWhatYouGet],
["UnitPageYieldBreakdown", LazyUnitPageYieldBreakdown],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
